import { EventType } from "./constants/event-type-constants";
import { DOMHelper } from "./helpers/dom-helper";
import { SubscriptionReactivationConstants, SubscriptionReactivationSelectors } from "./constants/subscription-reactivation-constans";
import { httpInstance } from "./http/http";
import { Utils } from "./utils/utils";
import { Spinner } from "./utils/spinner";
import { UtilizationConstants } from "./constants/marketing-client-utilization-constants";
export class SubscriptionReactivation {
    constructor(utilization) {
        this.closeButtons = [];
        this.isHarmonyTest = Utils.getURLParamsAsObject().enableHarmonyTest;
        this.path = this.isHarmonyTest ? "https://coreos07.wyborcza.pl:8094" : "https://squid-api.wyborcza.pl";
        this.utilization = utilization;
    }
    init() {
        this.initializeSection();
        if (!this.section)
            return;
        this.initializeButtons();
        this.initializeModals();
        this.initializeThankYouViews();
        this.bindEvents();
        if (!this.hasReactivationInLast10Minutes())
            return;
        this.showThankYouContent();
    }
    initializeSection() {
        this.section = DOMHelper.querySelector(SubscriptionReactivationSelectors.section);
    }
    initializeButtons() {
        this.returnSubscriptionButton = DOMHelper.querySelector(SubscriptionReactivationSelectors.returnSubscriptionButtonSelector);
        this.submitButton = DOMHelper.querySelector(SubscriptionReactivationSelectors.submitButtonSelector);
        this.closeButtons = DOMHelper.querySelectorAsArray(SubscriptionReactivationSelectors.closeButtonSelector);
        this.spinnerReactivateRecurringPlan = new Spinner(SubscriptionReactivationSelectors.spinner);
    }
    initializeModals() {
        this.returnSubscriptionModal = DOMHelper.querySelector(SubscriptionReactivationSelectors.returnSubscriptionModalSelector);
        this.errorModal = DOMHelper.querySelector(SubscriptionReactivationSelectors.errorModalSelector);
        this.thankYouModal = DOMHelper.querySelector(SubscriptionReactivationSelectors.thankYouModalSelector);
    }
    initializeThankYouViews() {
        this.content = DOMHelper.querySelector(SubscriptionReactivationSelectors.content);
        this.contentThankYou = DOMHelper.querySelector(SubscriptionReactivationSelectors.contentThankYou);
        this.bottomInfo = DOMHelper.querySelector(SubscriptionReactivationSelectors.bottom);
        this.bottomInfoThankYou = DOMHelper.querySelector(SubscriptionReactivationSelectors.bottomThankYou);
    }
    bindEvents() {
        this.bindEventsToShowSubsriptionModal();
        this.bindEventsToToggleModal();
        this.bindEventsToCloseButtons();
    }
    bindEventsToShowSubsriptionModal() {
        var _a;
        (_a = this.returnSubscriptionButton) === null || _a === void 0 ? void 0 : _a.addEventListener(EventType.CLICK, () => {
            Utils.showContainer(this.returnSubscriptionModal);
        });
    }
    bindEventsToToggleModal() {
        var _a;
        (_a = this.submitButton) === null || _a === void 0 ? void 0 : _a.addEventListener(EventType.CLICK, () => {
            this.spinnerReactivateRecurringPlan.show();
            this.reactivateRecurringPlan();
            this.utilize();
        });
    }
    bindEventsToCloseButtons() {
        this.closeButtons.forEach((closeButton) => {
            closeButton.addEventListener(EventType.CLICK, () => {
                this.closeModal(closeButton);
            });
        });
    }
    closeModal(closeButton) {
        const modalBackground = closeButton.closest(SubscriptionReactivationSelectors.modalBackgroundSelector);
        Utils.hideContainer(modalBackground);
    }
    reactivateRecurringPlan() {
        httpInstance
            .post({
            url: `${this.path}/squid-home/restricted/orders/reactivate-recurring-plan`,
            withCredentials: true
        })
            .then(this.successRegistrationAccount.bind(this), this.errorRegistrationAccount.bind(this))
            .then(() => {
            this.spinnerReactivateRecurringPlan.hide();
        });
    }
    successRegistrationAccount() {
        this.hideSubmitModal();
        this.showThankYouModal();
        this.showThankYouContent();
        this.setTimeLastReactivation();
    }
    errorRegistrationAccount() {
        this.hideSubmitModal();
        this.showErrorModal();
    }
    hideSubmitModal() {
        var _a;
        Utils.hideContainer((_a = this.submitButton) === null || _a === void 0 ? void 0 : _a.closest(SubscriptionReactivationSelectors.modalBackgroundSelector));
    }
    showThankYouModal() {
        var _a;
        Utils.showContainer((_a = this.thankYouModal) === null || _a === void 0 ? void 0 : _a.closest(SubscriptionReactivationSelectors.modalBackgroundSelector));
    }
    showErrorModal() {
        var _a;
        Utils.showContainer((_a = this.errorModal) === null || _a === void 0 ? void 0 : _a.closest(SubscriptionReactivationSelectors.modalBackgroundSelector));
    }
    showThankYouContent() {
        Utils.hideContainer(this.content);
        Utils.hideContainer(this.bottomInfo);
        Utils.showContainer(this.contentThankYou);
        Utils.showContainer(this.bottomInfoThankYou);
    }
    setTimeLastReactivation() {
        localStorage.setItem(SubscriptionReactivationConstants.SUBSCRIPTION_REACTIVATION_KEY, Date.now().toString());
    }
    hasReactivationInLast10Minutes() {
        const now = Date.now(), tenMinutesInMs = 10 * 60 * 1000, lastReactivation = localStorage.getItem(SubscriptionReactivationConstants.SUBSCRIPTION_REACTIVATION_KEY);
        if (!lastReactivation)
            return false;
        const timeSinceLastReactivation = now - parseInt(lastReactivation, 10);
        if (timeSinceLastReactivation <= tenMinutesInMs) {
            return true;
        }
        return false;
    }
    utilize() {
        var _a, _b;
        if (!((_a = this.section) === null || _a === void 0 ? void 0 : _a.parentElement))
            return;
        const condition = (_b = this.section.getAttribute(UtilizationConstants.dataUtilize)) !== null && _b !== void 0 ? _b : "brak", dataToSend = this.utilization.prepareDataToSend(this.section.parentElement, condition);
        this.utilization.sendBigDataEvent(this.section.parentElement, condition);
        this.utilization.utilize(dataToSend);
    }
}
